var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigntecLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 36,
    height: 26,
    rx: 4,
    fill: "#551FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 28,
    height: 18,
    rx: 2,
    fill: "white",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 16,
    height: 2.5,
    rx: 1.2,
    fill: "#551FFF",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 22,
    height: 2.5,
    rx: 1.2,
    fill: "#551FFF",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 12,
    height: 2.5,
    rx: 1.2,
    fill: "#551FFF",
    opacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 8,
    height: 3,
    rx: 1,
    fill: "#551FFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 33,
    width: 14,
    height: 2.5,
    rx: 1.2,
    fill: "#551FFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 30,
    fontFamily: "'Inter','Helvetica Neue',Arial,sans-serif",
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: -0.5,
    fill: "#551FFF"
  }, "Digntec")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigntecLogo);
export default __webpack_public_path__ + "static/media/DigntecLogo.9b61cd99a3b4b10c95d74266a64fa8c6.svg";
export { ForwardRef as ReactComponent };